<template>
  <div v-if="!showDetails">
    <app-history @clicked="$router.push('/jazb-history')" />
    <v-card class="form" v-if="plans.length > 0">
      <app-tarh v-for="index in plans.length" :key="index" :index="index - 1" :tarh="plans[index - 1]"
        :showDetails="false" @clicked="onClickRegister">
      </app-tarh>
    </v-card>
    <div v-else style="margin: 20px">در حال حاضر هیچ طرح فعالی وجود ندارد.</div>
  </div>
  <div v-else>
    <v-card>
      <v-card-title class="info-title">
        <div class="text-center">
          {{ selectedTarh.Title }}
        </div>
      </v-card-title>
      <app-row v-if="selectedTarh.Description" title="توضیحات" :value="selectedTarh.Description" />

      <div style="margin: 0 25px 0; padding: 10px 0 0">
        <h4>شرایط:</h4>
        <div style="
            border: 2px solid #996910;
            border-radius: 15px;
            margin: 15px 15px 0;
          ">
          <app-row title="حداقل پایه" :value="selectedTarh.PayehName" />
          <app-row title="جنسیت" :value="selectedTarh.Jensiat == 1
            ? 'آقا'
            : selectedTarh.Jensiat == 2
              ? 'خانم'
              : 'هردو'
            " />
          <app-row title="نیاز به تلبس" :value="selectedTarh.IsNeedTalabbos == 1 ? 'بله' : 'خیر'" />
          <app-row title="نیاز به تاهل" :value="selectedTarh.IsNeedTaahol == 1 ? 'بله' : 'خیر'" />
          <app-row title="نیاز به تایید مدرسه" :value="selectedTarh.IsNeedSchool == 1 ? 'بله' : 'خیر'" />
        </div>
      </div>
      <div class="HasRegistered" v-if="selectedTarh.OstadState == 1">
        {{
          "اساتيد رسمي حوزه علميه خراسان نیازی به ثبت نام در سامانه تبلیغ ندارند."
        }}
        برای درخواست تبلیغ به
        <a href="/ezamrequest"> این لینک </a>
        مراجعه فرمایید.
      </div>
      <div class="form" v-else-if="selectedTarh.RegisterState == 0">
        <v-row align="center" style="margin-top: 10px">
          <v-col class="d-flex" cols="12">
            <h3>شهر محل سکونت:</h3>
          </v-col>
          <v-col class="d-flex" cols="12" sm="12" md="6" lg="4">
            <b>استان</b>
            <v-select :items="ostans" item-text="text" item-value="value" v-model="ostan"></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" sm="12" md="6" lg="4">
            <b>شهرستان</b>
            <v-select :items="cities" item-text="text" item-value="value" v-model="cityId"></v-select>
          </v-col>
        </v-row>
        <v-row style="margin-top: 25px" v-if="selectedTarh.Priorities.length > 0">
          <v-col class="d-flex" cols="12" sm="12" md="6" lg="4">
            <b>اولویت</b>
            <v-select :items="selectedTarh.Priorities" item-text="text" item-value="value"
              v-model="priority"></v-select>
          </v-col>
        </v-row>
        <v-row style="margin-top: 25px">
          <v-col class="d-flex" cols="12">
            <b>ملاحظات:</b>
          </v-col>
          <v-col class="d-flex" cols="12">
            <v-textarea outlined v-model="description" no-resize style="margin: 15px 15px 0"
              placeholder="اگر اولویتی وجود دارد یا شرایط خاصی مدنظر شما است بفرمایید."></v-textarea>
          </v-col>
        </v-row>

        <v-row class="ltr">
          <v-btn color="primary white--text" class="register" rounded @click="applyRequest">
            ثبت نام
          </v-btn>
        </v-row>
      </div>
      <div class="HasRegistered" v-else-if="selectedTarh.RegisterState == 1">
        {{
          isHistory
            ? "شما پیشتر برای یکی از طرح ها ثبت نام نموده اید."
            : "درخواست با موفقیت ثبت شد. "
        }}
        برای مشاهده اطلاعات بیشتر به بخش
        <a href="/jazb-history"> مشاهده سوابق </a>
        مراجعه کنید.
      </div>
      <div class="HasRegistered" v-else-if="selectedTarh.RegisterState == 2">
        {{
          "شما در حال حاضر دارای پرونده تبلیغی هستید و نیازی به ثبت نام مجدد نیست."

        }}
        برای درخواست تبلیغ به
        <a href="/ezamrequest"> این لینک </a>
        مراجعه فرمایید.
      </div>
    </v-card>
  </div>
</template>

<script>
import Tarh from "./Tarh";
import DetailRow from "@/components/DetailRow";
import HistoryButton from "@/components/HistoryButton";
import { getAllTarh, saveJazb } from "@/api/jazb";
import { getAllOstanCity } from "@/api/location";

export default {
  data() {
    return {
      plans: [],
      selectedIndex: -1,
      description: "",
      isHistory: true,
      ostanCities: [],
      ostans: [],
      ostan: "9",
      //مشهد
      cityId: 2220092,
      priority: "",
    };
  },
  components: {
    appTarh: Tarh,
    appRow: DetailRow,
    appHistory: HistoryButton,
  },
  created() {
    if (this.$route.query.index) {
      this.$router.replace({
        query: {}
      })
    }
    this.getTarhha();
    getAllOstanCity()
      .then((response) => {
        this.ostanCities = response.data;
        let ostans = [];
        //همه موارد
        ostans.push({ value: "-1", text: "همه موارد" });
        this.ostanCities.map((item) => {
          if (!ostans.some((el) => el.value === item.srl_Ostan))
            ostans.push({ value: item.srl_Ostan, text: item.name_Ostan });
        });
        this.ostans = ostans;

        this.$store.commit("SET_PROGRESS_SHOW", false);
      })
      .catch((error) => {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
        );
      });
  },

  computed: {
    showDetails() {
      return this.selectedIndex > -1;
    },
    selectedTarh() {
      return this.selectedIndex != -1 ? this.plans[this.selectedIndex] : {};
    },
    cities() {
      let cities = [];
      //همه موارد
      cities.push({ value: "-1", text: "همه موارد" });
      this.ostanCities.map((item) => {
        if (item.srl_Ostan === this.ostan)
          cities.push({
            value: item.Fserial,
            text: item.name_City,
          });
      });
      return cities;
    },
  },
  methods: {
    /**
     * show available classes
     */
    getTarhha() {
      return new Promise((resolve, reject) => {
        getAllTarh(false)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.plans = response.data;

            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    onClickRegister(index) {


      window.scrollTo(0, 0);
      this.$router.push({
        query: {

          index: index
        }
      });
    },
    /**
     * check user input and  then send khorooj request
     */
    replaceNewLine(description) {
      const str = description.replace(/(?:\r\n|\r|\n)/g, "<br>");
      return str;
    },
    applyRequest() {
      if (this.cityId <= 0) {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          " شهر محل سکونت  بایستی انتخاب شود."
        );
        return;
      }
      if (this.selectedTarh.Priorities.length > 0 && this.priority == "") {
        this.$store.commit("SET_SNACKBAR_TEXT", " اولویت بایستی انتخاب شود.");
        return;
      }
      saveJazb({
        Srl_Tarh: this.selectedTarh.Fserial,
        description: this.replaceNewLine(this.description),
        cityId: this.cityId,
        Priority: this.priority,
      })
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          this.isHistory = false;
          this.getTarhha();
        })

        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
  },
  watch: {

    '$route'(to, from) {
      this.selectedIndex = this.$route.query.index ?? -1;
      this.isHistory = true;

    }
  },
};
</script>
<style scoped>
.form {
  display: flow-root;
}

.HasRegistered {
  margin: 25px;
  text-align: center;
  padding: 15px 15px;
  color: black;
  /* border: 3px solid #0f2204;
  border-radius: 15px; */
  font-weight: bold;
  display: inline-block;
  text-align: justify;
  font-size: 90%;
}
</style>
